import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './strategy/widgetSettingComposing/widgetSettingComposingStrategy'

export const composeDrillDownWidgetSettingWithMultiStrategies = (
  strategies: WidgetSettingComposingStrategy[],
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => {
  const drillDownWidgetSetting = {} as DashboardWidgetType

  const keys = Object.keys(widgetSetting) as Array<keyof DashboardWidgetType>

  keys.forEach((key) => {
    if (widgetSetting[key] != null) {
      // @ts-ignore
      drillDownWidgetSetting[key] = widgetSetting[key]!
    }
  })

  if (strategies.find((strategy) => !strategy.canBeDrilledDown(widgetSetting))) {
    return drillDownWidgetSetting
  }

  if (strategies.find((strategy) => strategy.isOverMaxInput(insights))) {
    return drillDownWidgetSetting
  }

  return strategies.reduce(
    (accumulator, strategy) => ({
      ...accumulator,
      ...strategy.composeDrillDownWidgetSetting(drillDownWidgetSetting, insights)
    }),
    {} as any
  )
}

export default composeDrillDownWidgetSettingWithMultiStrategies
